import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from '@/app';
import Maintenance from '@/pages/maintenance/maintenance-page';
import PWAUpdatePrompt from '@/components/shared/pwa-update-prompt';
import ThemeOverride from '@/components/shared/theme-override';
import { MAINTENANCE_MODE } from '@/lib/constants';
import { isNativePlatform } from '@/lib/capacitor';

/*
 * Pas de nouvelle tentative automatique ni de rechargement au retour sur l'onglet : l'ancien
 * store redux ne relançait jamais un appel de lui-même, et un formulaire en cours de saisie ne
 * doit pas voir ses données de référence bouger sous lui.
 */
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

const AppProvider = () => {
    return (
        <QueryClientProvider client={queryClient}>
            {/* Maintenance planifiée (VITE_MAINTENANCE_MODE) : l'app n'est pas montée, donc aucun appel API */}
            {MAINTENANCE_MODE ? <Maintenance /> : <App />}
            <ThemeOverride />
            {/* Mise à jour auto du SW (web uniquement, pas dans l'app native Capacitor) */}
            {!isNativePlatform() && <PWAUpdatePrompt />}
        </QueryClientProvider>
    );
};

export default AppProvider;
